import type { FunctionComponent } from 'react';

import styles from './BoardHeaderButtonDivider.less';

export const BoardHeaderButtonDivider: FunctionComponent = () => {
  return <span className={styles.boardHeaderButtonDivider} />;
};
